<!-- Loading Screen -->
<div
  *ngIf="isLoading"
  class="loading-overlay d-flex flex-column justify-content-center align-items-center"
>
  <div class="spinner-ring position-relative">
    <div class="spinner-border"></div>
    <img src="assets/images/loading/loading-screen.gif" alt="goalngo Logo" class="spinner-logo" />
  </div>
  <p class="text-white fs-3 mt-4">Your request is being processed...</p>
</div>
